import dayjs from 'dayjs';
import { FC } from 'react';
import { Modal, ModalProps } from '../../../../../../components/modal/modal';
import { Table } from '../../../../../../features/table/table';
import { TableFilterDateRange } from '../../../../../../features/table/table-filter/table-filter-date-range/table-filter-date-range';
import { TableFilterInput } from '../../../../../../features/table/table-filter/table-filter-input/table-filter-input';
import { formatRuDateString } from '../../../../../../helpers/date-time';
import { useLang } from '../../../../../../hooks/use-lang';
import { IdValue } from '../../../../../../types/props';
import s from './check-in-check-out-history-modal.module.css';
import { useCheckInCheckOutHistoryModal } from './use-check-in-check-out-history-modal';

const getTime = (date: string | null) => (date ? dayjs(date).format('HH:mm') : null);

const getTimeGroup = (
  oldStartTime: string | null,
  newStartTime: string | null,
  oldEndTime: string | null,
  newEndTime: string | null,
) =>
  [
    [getTime(oldStartTime), getTime(newStartTime)].filter(Boolean).join(' → '),
    [getTime(oldEndTime), getTime(newEndTime)].filter(Boolean).join(' → '),
  ]
    .filter(Boolean)
    .join(', ');

interface Props extends ModalProps {
  employees?: IdValue[];
}

export const CheckInCheckOutHistoryModal: FC<Props> = ({ employees, onClose }) => {
  const { t } = useLang();
  const { checkinsHistory, isLoadingHistoryFetch, paginationHistory } =
    useCheckInCheckOutHistoryModal();

  return (
    <Modal className={s.feature} onClose={onClose} title={t('История изменений')}>
      <Table
        pagination={paginationHistory}
        isLoading={isLoadingHistoryFetch}
        pagePrefix="checkins-history_"
        className={s.table}
        cols={{
          date: {
            label: t('Дата'),
            filter: <TableFilterDateRange name="historyDate" />,
          },
          employee: {
            label: t('Сотрудник'),
            filter: (
              <TableFilterInput
                name="historyEmployee"
                suggestOptions={employees?.map((item) => item.value)}
              />
            ),
          },
          changes: {
            label: t('Что изменено'),
          },
          author: {
            label: t('Кто внес изменения'),
            filter: <TableFilterInput name="historyAuthor" />,
          },
          reason: {
            label: t('Причина'),
            filter: <TableFilterInput name="historyReason" />,
          },
        }}
        rows={checkinsHistory?.map((item) => {
          return {
            date: item.updated_at ? formatRuDateString(item.updated_at) : '-',
            employee: item.checkin_staff_name,
            changes: (
              <>
                <div>
                  {t('Сеанс за')} {formatRuDateString(item.old_start_time)}:
                </div>

                <br />

                {item.action === 'delete' && (
                  <div>
                    {t('Удалены промежуточные сеансы')}:{' '}
                    {getTimeGroup(item.old_start_time, item.old_end_time, null, null)}
                  </div>
                )}

                {item.action === 'update' && (
                  <>
                    <div>
                      1. {t('Приход')}:{' '}
                      {getTimeGroup(item.old_start_time, item.new_start_time, null, null)}
                    </div>

                    <div>
                      2. {t('Уход')}:{' '}
                      {getTimeGroup(item.old_end_time, item.new_end_time, null, null)}
                    </div>
                  </>
                )}
              </>
            ),
            author: item.updated_by_name,
            reason: item.reason,
          };
        })}
      />
    </Modal>
  );
};
